import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { SupportEnvironment } from '@app/multi-environment/support-environment'
import { SupportLink, SupportLinkResolver, SupportResource } from '@app/multi-environment/support-link.resolver'
import { ATLAS_ENVIRONMENTS } from './environments'

/**
 * Atlas holds no detail pages of its own: every row belongs to an environment, and following it
 * means leaving this origin for that environment's own support UI.
 */
@Injectable()
export class AtlasSupportLinkResolver extends SupportLinkResolver {
  // Reaching a row at all means the environment answered a SUPPORT-only endpoint for this viewer,
  // so there is no weaker case to render.
  canFollowSupportLinks(): Observable<boolean> {
    return of(true)
  }

  linkTo(environment: SupportEnvironment | undefined, resource: SupportResource, id: number): SupportLink {
    const origin = environment?.origin ?? ATLAS_ENVIRONMENTS[0].origin
    return { routerLink: null, href: `${origin}/app/support/${resource}/${id}` }
  }
}
